/**
 * Is String
 */
const isString = <T>(target: T) => typeof target === 'string';

export { isString };
